"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
exports.colors = {
    "Primary": "#1fab2e",
    "Secondary": "#003025",
    "White": "#ffffff",
    "WaveBlue": "#77acc7",
    "WaveBlue25": "#ddeaf1",
    "WaveBlue50": "#bbd5e3",
    "WaveBlue200": "#327ea4",
    "Sand": "#c3ab77",
    "Sand25": "#f0eadd",
    "Sand50": "#e1d5bb",
    "Sand200": "#8a723d",
    "Mint": "#b5c9b9",
    "Mint25": "#ecf1ed",
    "Mint50": "#dae4dc",
    "Mint200": "#5d7e64",
    "Text": "#191919",
    "TextLink": "#1a8924",
    "Success": "#1fab2e",
    "Success10": "#e9f7ea",
    "Error": "#d31a20",
    "Error10": "#fae8e8",
    "ErrorDark": "#ff2a2a",
    "Info": "#266df5",
    "Info10": "#e9f0fe",
    "Warning": "#ff8a00",
    "Warning10": "#fff3e6",
    "Grey1": "#191919",
    "Grey2": "#383838",
    "Grey3": "#484848",
    "Grey4": "#a2a2a2",
    "Grey5": "#d9d9d9",
    "Grey6": "#f0f0f0",
    "Grey7": "#fafafa"
};
//# sourceMappingURL=index.js.map